/* shah */
import React from 'react'

const DarkModeIcon = () => {
    return (
        <svg id="SmallBoxSVG-darkMode" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M2335 4633 c-262 -32 -486 -98 -710 -210 -610 -305 -1031 -891 -1129
-1570 -21 -148 -21 -438 0 -586 86 -596 422 -1124 924 -1453 227 -148 490
-254 765 -305 139 -27 466 -37 611 -20 395 46 771 203 1074 448 90 73 249 233
321 323 225 282 381 643 433 1007 21 148 21 438 0 586 -86 596 -421 1122 -924
1453 -259 170 -574 284 -890 324 -78 9 -406 12 -475 3z m65 -2072 l0 -1749
-42 5 c-87 10 -243 45 -337 74 -130 41 -355 154 -471 236 -122 87 -336 301
-423 423 -82 116 -195 341 -236 471 -65 208 -75 281 -75 539 0 207 2 247 22
339 122 560 474 1010 975 1246 183 86 356 135 580 164 4 1 7 -786 7 -1748z"/>
            </g>
        </svg>
    )
}

export default DarkModeIcon